import * as yup from "yup";
import { SelectOptions } from "hooks";
import { FilterViewModel } from "api/factories/ulits.factory";

export interface CreateEmailSchedulerRuleForm {
    general: GeneralConfigViewModel;
    filters: FilterViewModel[];
    actions: ActionViewModel[];
}

export interface GeneralConfigViewModel {
    id?: Readonly<string>;
    deadlineMaterial: string;
    initialStatuses?: SelectOptions[];
    name: string;
    exceptions: ExceptionCheckbox[];
    active: boolean;
    weekends: boolean;
    order: boolean;
}

export interface ExceptionCheckbox {
    name: string;
    isChecked: boolean;
}

export interface ActionViewModel {
    template: string;
    status: string;
    startsAt: {
        days: string;
        hours: string;
        minutes: string;
    };
}

export const orders = [
    { name: "Campaign", value: true },
    { name: "Lineitem", value: false },
];

export const createDefaultRuleDefaultFormValues: CreateEmailSchedulerRuleForm = {
    general: {
        active: false,
        weekends: false,
        order: orders[0].value,
        name: "",
        deadlineMaterial: "",
        exceptions: [],
    },
    filters: [{ name: "", operator: "", logicalOperator: "", type: "" }],
    actions: [
        {
            status: "",
            template: "",
            startsAt: {
                minutes: "0",
                days: "0",
                hours: "0",
            },
        },
    ],
};

export const emailConfigurationSchema = yup.object().shape({
    exceptions: yup.array().of(
        yup.object().shape({
            name: yup.string(),
            isChecked: yup.boolean(),
        })
    ),
    general: yup.object().shape({
        deadlineMaterial: yup.string().required("Material deadline is required"),
        initialStatuses: yup.array().min(1, "Initial status must have at least 1 item").required(),
        // .of(
        //     yup.object().nullable().default({}).shape({
        //         name: yup.string(),
        //         value: yup.string(),
        //     })
        // ),
        name: yup.string().required("Rule name is required"),
        active: yup.boolean(),
        weekends: yup.boolean(),
        order: yup.boolean(),
    }),
    filters: yup
        .array()
        .min(1)
        .of(
            yup.object().shape({
                name: yup.string().required("Field is required"),
                operator: yup.string().required("Operator is required"),
                options: yup
                    .array()
                    .min(1, "Value must have at least 1 item")
                    .required()
                    .of(
                        yup.object().nullable().default({}).shape({
                            name: yup.string(),
                            value: yup.string(),
                        })
                    ),
                logicalOperator: yup.string(),
            })
        ),
    actions: yup
        .array()
        .min(1)
        .of(
            yup.object().shape({
                startsAt: yup.object().shape({
                    days: yup
                        .number()
                        // eslint-disable-next-line
                        .min(0, "Days must be greater than or equal to ${min}")
                        // eslint-disable-next-line
                        .max(31, "Days must be less than or equal to ${max}"),
                    hours: yup
                        .number()
                        // eslint-disable-next-line
                        .min(0, "Hours must be greater than or equal to ${min}")
                        // eslint-disable-next-line
                        .max(24, "Hours must be less than or equal to ${max}"),
                    minutes: yup
                        .number()
                        // eslint-disable-next-line
                        .min(0, "Minutes must be greater than or equal to ${min}")
                        // eslint-disable-next-line
                        .max(60, "Minutes must be less than or equal to ${max}"),
                }),
                template: yup.string(),
                status: yup.string().when("template", {
                    is: (template: string) => template === "",
                    then: yup.string().required("Status is required"),
                    otherwise: yup.string().optional(),
                }),
            })
        ),
});
